export const fileUploadPlatformKeys = [
  "ukbd",
  "trlg",
  "accountingfileupload",
  "bankingfileupload",
  "njmc",
];
